/**
 * Begin the key validation check
 *
 * @param  {Object} state
 * @return {Void}
 */
const KEY_VALIDATION_LOADING = (state) => {
    state.loading = true
}

/**
 * Handle the key validation success state
 *
 * @param  {Object} state
 * @param  {Object} payload
 * @return {Void}
 */
const KEY_VALIDATION_SUCCESS = (state, payload) => {
    state.conf_agreement = payload.conf_agreement
    state.loading = false
    state.success = true
}

/**
 * Handle the key validation failure
 *
 * @param  {Object} state
 * @return {Void}
 */
const KEY_VALIDATION_FAILURE = (state) => {
    state.error = 'There was a problem with your request. Please try again.'
    state.loading = false
}

export default {
    KEY_VALIDATION_LOADING,
    KEY_VALIDATION_SUCCESS,
    KEY_VALIDATION_FAILURE
}



// WEBPACK FOOTER //
// ./src/state/modules/shared/mutations.js